import { makeStyles } from "@material-ui/core/styles";

export const SystemUserStyles = makeStyles((theme) => ({
  mainContainer: {
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "0em !important",
      paddingRight: "0em !important",
    },
  },
  cardContainer: {
    paddingBottom: "1em",
  },
  title: {
    marginTop: "1em",
    marginBottom: "1em",
    color: "#002453",
  },
  privacyTitleCard: {
    backgroundColor: "#f3f2f2",
    borderRadius: "2em",
    marginLeft: "5em",
    marginRight: "5em",
    marginBottom: "3em",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0.5em",
      marginRight: "0.5em",
    },
  },
  media: {
    height: "100%",
    width: "auto",
  },
  imgCardMedia: {
    width: "auto",
    height: "12em",
  },
  privacyTitleCardTextContainer: {
    marginTop: "auto",
    marginBottom: "auto",
    paddingRight: "5em",
    [theme.breakpoints.down("sm")]: {
      paddingRight: "0em !important",
      marginBottom: "1em",
    },
  },
  privacyTitleCardText: {
    fontSize: "120%",
    textAlign: "left",
    color: "#666666",
    marginRight: "2em",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "1em",
      marginRight: "1em !important",
      paddingRight: "0em !important",
    },
  },
  containerMargin: {
    marginLeft: "5em",
    marginRight: "5em",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "1em !important",
      marginRight: "1em !important",
    },
  },
  rgpdTitle: {
    marginBottom: "2em",
  },
  imgIcon: {
    marginTop: "auto",
    marginBottom: "auto",
    height: "1.5em",
    width: "auto",
    overflow: "auto",
    color: "#002453",
    borderRadius: "50%",
    backgroundColor: "#f3f2f2",
    border: "7px solid #f3f2f2",
  },
  rgpdTitleText: {
    color: "#333333",
    marginTop: "auto",
    marginBottom: "auto",
    marginLeft: "1em",
    fontSize: "150%",
  },
  tycInfoHeader: {
    textAlign: "left",
    paddingLeft: "1em",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      paddingLeft: "0em",
    },
  },
  tycInfoHeader2: {
    textAlign: "left",
    paddingLeft: "0.5em",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      paddingLeft: "0em",
    },
  },
  titleColumn: {
    color: "#002453",
    fontSize: "120%",
    [theme.breakpoints.down("sm")]: {
      fontSize: "80%",
    },
  },
  evenRow: {
    backgroundColor: "#f3f2f2",
    borderRadius: "0.5em",
    paddingRight: "1em",
  },
  oddRow: {
    paddingRight: "1em",
  },
  tycsApps: {
    marginTop: "1em",
    marginBottom: "1em",
    
    textAlign: "left",
    color: "#666666",
    paddingLeft: "1em",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "0.5em",
      textAlign: "center",
    },
  },
  signedText: {
    textAlign: "left",
    color: "#666666",
    paddingLeft: "1em",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "1.5em !important",
      marginRight: "0em !important"
    }
  },
}));
